import { rem } from 'polished'

/**
 * Use as `min-height` or to derive related spacing so wrapping labels can grow.
 */
export const MIN_LABEL_HEIGHT = rem(24)
